// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.1.0",
  date: "2026-06-12T14:41:32.562Z",
  gitInfo: {
    dirty: false,
    raw: "907a099b5",
    hash: "907a099b5",
    distance: null,
    tag: null,
    semver: null,
    suffix: "907a099b5",
    semverString: null
  }
};
/* tslint:enable */
